import PropTypes from 'prop-types'
import React from 'react'
import styles from './_field.css'
import classnames from 'classnames'

const propTypes = {
  showError: PropTypes.bool,
  errorComponent: PropTypes.node,
  errorMessage: PropTypes.string,
  className: PropTypes.string,
}

export function FieldError ({ className, showError, errorComponent, errorMessage }) {
  return (
    <div className={classnames(styles.errorMessage, className, { [styles.show]: showError })}>
      {showError && errorComponent ?
        React.cloneElement(errorComponent, { errorMessage })
      : null}
    </div>
  )
}

FieldError.propTypes = propTypes

export default FieldError



// WEBPACK FOOTER //
// ./src/components/forms/FieldError.jsx